module.exports = __webpack_public_path__ + "media/send_order.0f32ed3f.mp3";